// 
// Sundae Lane Product Inventory Summary
// - 
// 
window.theme = window.theme || {};

theme.InventorySummary = (function() {

  function InventorySummary(container) {
    this.container = container;

    if(!container){
      return;
    }

    this.current = {
      variantId: null,
      variant: null
    }

    this.statuses = {
      "in_stock": [
        {
          in_stock: true,
          estimated_arrival_date: false,
          preorder_quantity_available: false,
          item_product: true
        },
        {
          in_stock: true,
          estimated_arrival_date: false,
          preorder_quantity_available: false,
          item_product: false
        }
      ],
      "in_stock_and_production": [
        {
          in_stock: true,
          estimated_arrival_date: true,
          preorder_quantity_available: true,
          item_product: true
        },
        {
          in_stock: true,
          estimated_arrival_date: true,
          preorder_quantity_available: true,
          item_product: false
        }
      ],
      "under_production": [
        {
          in_stock: false,
          estimated_arrival_date: true,
          preorder_quantity_available: true,
          item_product: true
        },
        {
          in_stock: false,
          estimated_arrival_date: true,
          preorder_quantity_available: true,
          item_product: false
        }
      ],
      "out_of_stock": [
        {
          in_stock: false,
          estimated_arrival_date: false,
          preorder_quantity_available: false,
          item_product: true
        },
        {
          in_stock: false,
          estimated_arrival_date: true,
          preorder_quantity_available: false,
          item_product: true
        }
      ],
      "made_to_order": [
        {
          in_stock: false,
          estimated_arrival_date: false,
          preorder_quantity_available: false,
          item_product: false
        },
        {
          in_stock: false,
          estimated_arrival_date: true,
          preorder_quantity_available: false,
          item_product: false
        }
      ]
    }
    

    this.sectionId = this.container.id;
    this.themeData = this.parseThemeData();

    this.bindElements();
    this.bindEvents();

  }

  InventorySummary.prototype = {

    parseThemeData: function(){
      const themeDataContainer = document.querySelector(`[data-section="${this.sectionId}"]`)
      if (!themeDataContainer){
        console.log('error: Unable to load settings for marquee section')
        return;
      }

      const themeData = JSON.parse(themeDataContainer.innerHTML);
      if (!themeData){
        console.log('Error: Unable to find theme data');
        return;
      }
      return themeData;
    },

    bindElements: function(){
      const self = this;
      
      self.variantSelect = document.querySelector('[data-product-select]');
      self.statusContainers = document.querySelectorAll('.inventory-summary-status');
    },

    bindEvents: function(){
      const self = this;
      
      self.onPageLoad();

      document.addEventListener('variant:change', function(event) {
        let variant = event.detail.variant;
        
        if (!variant || !variant.id){
          console.log('Error: invalid variant id');
          self.current.status = 'error';
          self.showError();
          return;
        }

        self.setCurrentVariant(variant.id);
        self.setInventoryStatus();
        self.updateInventorySummary();
      });
    },

    getSelectedVariant: function(){
      const self = this;
      let selectedVariantOption = self.variantSelect.options[self.variantSelect.selectedIndex];
      if (!selectedVariantOption){
        selectedVariantOption = self.variantSelect.options[0]; 
      }
      currentVariantId = selectedVariantOption.value;
      return currentVariantId;
    },
 
    setCurrentVariant: function(variantId){
      const self = this;

      self.current.variantId = variantId;

      self.current.variant = self.themeData.find(function(item){
        if (item.variantId == self.current.variantId){
          return item;
        }
      });

      self.current.summary = {};

      Object.keys(self.current.variant.summary).forEach(function(key){
        let property = self.current.variant.summary[key];
        if (property != null){
          let statusCondition = (property != 'false' && property != '0 items available' && property != 'Made to order' && property != '0 Items') || property == 'Vorsen stocked item';
          self.current.summary[key] = { property: property, status: statusCondition };
        }
      });

      // console.log(self.current.summary);
    },

    removeLoading: function(){
      const self = this;
      let loadingContainer = document.querySelector('.product-block--inventory-summary');
      if (!loadingContainer){
        console.log('Error: Unable to find loading container');
        return;
      }
      loadingContainer.classList.remove('loading');
    },

    onPageLoad: function(){
      const self = this;
      
      const variantId = self.getSelectedVariant();
      if (!variantId){
        self.current.status = 'error';
        self.showError();
        return;
      }
      self.setCurrentVariant(variantId);
      self.setInventoryStatus();
      self.updateInventorySummary();
    },

    setInventoryStatus: function(){
      const self = this;
    
      let foundStatus = null;
    
      // Iterate over each status key
      Object.keys(self.statuses).some(function(key){
        // Iterate over each set of conditions for the current status
        return self.statuses[key].some(function(condition){
          let pass = 0;
          // Check each itemKey against the current summary
          Object.keys(condition).forEach(function(itemKey){
            if (self.current.summary[itemKey] && condition[itemKey] == self.current.summary[itemKey].status){
              pass++;
            }
          });
          // If all conditions are met, set the foundStatus
          if (pass == 4){
            foundStatus = key;
            return true; // Break out of the inner loop
          }
          return false; // Continue to the next set of conditions
        });
      });
    
      self.current.status = foundStatus;
    
      if (!self.current.status){
        console.log('Error: Unable to set status');
        self.current.status = 'error';
        self.showError();
        return;
      }
      // console.log(self.current.status)
    },    

    showError: function(){
      const self = this;
      self.hideAllStatusContainers();
      
      const activeStatusContainer = self.container.querySelector(`[data-status="${self.current.status}"]`);
      activeStatusContainer.classList.remove('hide');

      self.removeLoading();
    },

    updateInventorySummary: function(){
      const self = this;

      self.hideAllStatusContainers();

      if (self.current.status === 'under_production') {
        self.updateAddToCartButtonText(window.theme.strings.preOrderText);
      } else {
        self.updateAddToCartButtonText(window.theme.strings.addToCartText);
      }
      
      if (self.current.status == 'error'){
        const activeStatusContainer = self.container.querySelector(`[data-status="${self.current.status}"]`);
        activeStatusContainer.classList.remove('hide');
        return;
      }

      const activeStatusContainer = self.container.querySelector(`[data-status="${self.current.status}"]`);
      activeStatusContainer.classList.remove('hide');

      Object.keys(self.current.variant.summary).forEach(function(key){
        let property = self.current.summary[key].property;
        if (property && property != 'false'){
          const valueContainer = activeStatusContainer.querySelector(`[data-item="${key}"] .inventory-summary__value`);

          if (!valueContainer){
            return;
          }
          
          if (key == 'in_stock'){
            property = property.replace(/^(\d+)/, '<strong>$1</strong>');
          }

          // if (key == 'preorder_quantity_available'){
          //   property = property.replace(/^(\d+)/, '<strong>$1</strong>');
          // }

          valueContainer.innerHTML = property;
        }
      });

      self.removeLoading();
      
    },

    updateAddToCartButtonText: function(newText) {
      const addToCartButton = document.querySelector('span[data-add-to-cart-text]');
      if (addToCartButton) {
        addToCartButton.textContent = newText;
      }
    },

    hideAllStatusContainers: function(){
      const self = this;

      self.statusContainers.forEach(function(item){
        item.classList.add('hide');
      });
    }

  }

  return InventorySummary;

})();

document.addEventListener('DOMContentLoaded', function() {
  const inventorySummaryContainers = document.querySelectorAll('.product-block--inventory-summary');
  if (!window.theme.inventorySummaries && inventorySummaryContainers){
    window.theme.inventorySummaries = []
    inventorySummaryContainers.forEach(function(container){
      window.theme.inventorySummaries.push(new theme.InventorySummary(container));
    });
  }
});
